import React from "react";

export default function PaypalIcon() {
  return (
    <svg width={17} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#003087"
        d="M14.56 3.713c.12-1.071-.093-1.832-.702-2.526C13.128.356 11.812 0 10.126 0H5.234a.7.7 0 0 0-.691.59L2.505 13.509a.42.42 0 0 0 .415.486h2.756l-.202 1.28a.628.628 0 0 0 .62.726H8.64c.429 0 .793-.31.862-.731l.025-.13.48-3.043.03-.164.001-.007a.351.351 0 0 1 .348-.297h.38c1.266 0 2.425-.256 3.345-.91.379-.27.712-.603.993-1.005a4.942 4.942 0 0 0 .88-2.195c.243-1.246.13-2.356-.57-3.154a2.687 2.687 0 0 0-.76-.59l-.094-.061ZM7.043 8.82a.695.695 0 0 1 .321-.079H8.8c2.82 0 5.027-1.144 5.672-4.456l.003-.016c.217.124.4.27.548.438.546.623.679 1.535.45 2.71-.272 1.397-.866 2.307-1.663 2.874-.802.57-1.842.815-3.043.815h-.38a.873.873 0 0 0-.863.734l-.03.164-.48 3.043-.024.13-.001.004a.352.352 0 0 1-.348.296H6.095a.106.106 0 0 1-.105-.123l.208-1.32.845-5.214Z"
      />
    </svg>
  );
}
